export function isRedirect(response,router){
    console.log(response);
    
    // if(_.get(err,'response')){
    //     switch(err.response.status){
    //         case 404:
    //         router.push({name:'404'}).catch(err=>{})
    //         break;
    //         case 403:
    //         router.push({name:'404'}).catch(err=>{})
    //         break;
    //         case 500:
    //         router.push({name:'ServerError'}).catch(err=>{})
    //         break;
    //         default: console.log(err)
    //     }
    // }
}


// WEBPACK FOOTER //
// ./resources/js/mixins/redirectHandler.js